import './styles.scoped.css'
import {useEffect, useState} from 'react'
import {Typography, Button, Modal, TextField, FormControl, Select, MenuItem, Checkbox, ListItemText, InputAdornment} from '@mui/material'
import {Search} from '@mui/icons-material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {clientApi, caregiverApi} from '../../../../services'
import {parseError} from '../../../../utils/helpers'
import {SkeletonContainer, FieldSkeleton} from '../../../../components'
import {useParams} from 'react-router-dom'

export default ({open, setOpen, loadData, oldServices, caregiverName}) => {
    const {setLoading, setMessageBox, branchId} = useGlobalStates()
    const {caregiverId} = useParams()
    const [services, setServices] = useState([])
    const [selectedServices, setSelectedServices] = useState([])
    const [searchServiceTerm, setSearchServiceTerm] = useState('')
    const [skeleton, setSkeleton] = useState(true)
    const filteredServices = services.filter(item => item.display_name.toLowerCase().includes(searchServiceTerm.toLowerCase()))

    useEffect(() => {
        setServices([])
        setSelectedServices([])
        setSearchServiceTerm('')
        setSkeleton(true)
        const timeout = setTimeout(() => {
            if (branchId) {
                clientApi
                    .getBranchServices({branch_id: branchId})
                    .then(({data: {data}}) => {
                        setSkeleton(false)
                        setServices(data?.map(item => ({id: item?.service_id, display_name: item?.service_name})))
                    })
                    .catch(error => {
                        setSkeleton(false)
                        const {title, description} = parseError(error)
                        if (description) {
                            setMessageBox({status: 'error', title, description})
                        }
                    })
            }

            if (oldServices) {
                setSelectedServices(oldServices?.map(s => s.service_id))
            }
        }, 100)
        return () => clearTimeout(timeout)
    }, [open, branchId, oldServices])

    const submit = () => {
        if (selectedServices?.length == 0) {
            setMessageBox({
                status: 'warning',
                title: 'No Service Selected!',
                description: 'Please select a service.',
            })
            return
        }
        setLoading(true)
        caregiverApi
            .saveCaregiverServices(branchId, caregiverId, {
                service_ids: selectedServices,
            })
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Service Assigned!',
                    description: `${caregiverName} has been assigned to service.`,
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    const serviceChange = event => {
        const value = event.target.value
        if (value.includes('all')) {
            if (selectedServices.length === services.length) {
                setSelectedServices([])
            } else {
                setSelectedServices(services.map(item => item.id))
            }
        } else {
            setSelectedServices(value)
        }
    }

    const renderServiceLabel = selecteds => {
        if (selecteds.length === services.length) {
            return 'All Services'
        }
        return services
            .filter(item => selecteds.includes(item.id))
            .map(item => item.display_name)
            .join(', ')
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            Assign a New Service
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        Select a new service to assign to Andy.
                    </Typography>
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Service{' '}
                        <Typography variant="inputLabel" color="error">
                            *
                        </Typography>
                    </Typography>
                    {skeleton ? (
                        <SkeletonContainer>
                            <FieldSkeleton label={false} />
                        </SkeletonContainer>
                    ) : (
                        <FormControl fullWidth>
                            <Select
                                multiple
                                value={selectedServices}
                                onChange={serviceChange}
                                renderValue={renderServiceLabel}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            overflow: 'auto',
                                        },
                                    },
                                }}>
                                <MenuItem disableRipple disableTouchRipple onClick={e => e.stopPropagation()}>
                                    <TextField
                                        placeholder="Search service name..."
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={searchServiceTerm}
                                        onChange={e => setSearchServiceTerm(e.target.value)}
                                        onClick={e => e.stopPropagation()}
                                        onKeyDown={e => e.stopPropagation()}
                                        slotProps={{
                                            input: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            },
                                        }}
                                    />
                                </MenuItem>
                                <MenuItem value="all">
                                    <Checkbox
                                        checked={selectedServices.length === services.length}
                                        indeterminate={selectedServices.length > 0 && selectedServices.length < services.length}
                                    />
                                    <ListItemText primary="Select All" />
                                </MenuItem>
                                {filteredServices.map(item => (
                                    <MenuItem key={item.id} value={item.id}>
                                        <Checkbox checked={selectedServices.includes(item.id)} />
                                        <ListItemText primary={item.display_name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    <br />
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth onClick={submit}>
                            Assign Service
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
